'use client';

import React, { useCallback } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useInstantSearch } from 'react-instantsearch-next';
import { useHistory } from 'react-router-dom';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';

/**
 * See full results button with dynamic hit count (v7 version)
 * This component is only used in new consumer app
 */
const SeeFullResultsButtonNext = () => {
  const { results } = useInstantSearch();
  const closeSearch = useCloseSearch();
  const history = useHistory();
  const currentPage = useUserCurrentPageType();

  const handleClick = useCallback(
    e => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (results?.query) {
        avo.productsSearched({
          query: results.query,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS,
        });
        const newUrl = getAdvancedSearchUrlForQueryAndIndex(
          results.query,
          ALGOLIA_INDEX_NAME.PRODUCTS,
          '*'
        );
        history.push(newUrl, {
          instantQuery: results.query,
        });
        closeSearch();
      }
    },
    [closeSearch, history, results?.query, currentPage]
  );

  if (!results || !results.query) {
    return null;
  }

  return (
    <button
      type="button"
      className="[text-decoration:none]"
      aria-label={`See all ${results.nbHits} results for ${results.query}`}
      onClick={handleClick}
    >
      <div className="bg-gray text-white text-base font-bold px-6 py-3 font-semibold text-sm hover:bg-gray-800 transition-colors">
        See full results ({results.nbHits})
      </div>
    </button>
  );
};

export default SeeFullResultsButtonNext;
